export default "__VITE_ASSET__BOxMaCZi__"